import { Box, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const DataGridComponent = ({
  isLoading,
  consommations,
  columns,
  noResultsMessage,
}) => {
  const theme = useTheme();

  return (
    <Box
      gridColumn="span 8"
      gridRow="span 3"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        height: "100%",
        overflowX: "auto",
        overflowY: "hidden",

        "& .MuiDataGrid-root": {
          border: "none",
          borderRadius: "1rem",
          height: "100%",
          minWidth: {
            xs: "950px",
            md: "100%",
          },
          backgroundColor: theme.palette.background.alt,
        },

        "& .MuiDataGrid-cell": {
          borderBottom: "1px solid rgba(255, 255, 255, 0.14)",
          color: theme.palette.secondary[100],
          fontWeight: "600",
        },

        "& .MuiDataGrid-row": {
          borderBottom: "1px solid rgba(255, 255, 255, 0.14)",
        },

        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: theme.palette.background.alt,
          color: theme.palette.secondary[100],
          borderBottom: "1px solid rgba(255, 255, 255, 0.18)",
        },

        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: "700",
        },

        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: theme.palette.background.alt,
        },

        "& .MuiDataGrid-footerContainer": {
          backgroundColor: theme.palette.background.alt,
          color: theme.palette.secondary[100],
          borderTop: "1px solid rgba(255, 255, 255, 0.14)",
        },

        "& .MuiTablePagination-root": {
          backgroundColor: theme.palette.background.alt,
          color: theme.palette.secondary[100],
        },
      }}
    >
      <DataGrid
        loading={isLoading}
        getRowId={(row) => row.id}
        rows={consommations}
        columns={columns}
        components={{
          NoRowsOverlay: () => (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: theme.palette.secondary[200],
              }}
            >
              <Typography variant="h6">
                {noResultsMessage || "Aucune donnée disponible"}
              </Typography>
            </Box>
          ),
        }}
      />
    </Box>
  );
};

export default DataGridComponent;



// import { Box, Typography, useTheme } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";

// const DataGridComponent = ({
//   isLoading,
//   consommations,
//   columns,
//   noResultsMessage,
// }) => {
//   const theme = useTheme();

//   return (
//     <Box
//       gridColumn="span 8"
//       gridRow="span 3"
//       sx={{
//         width: "100%",
//         maxWidth: "100%",
//         minWidth: 0,
//         overflowX: "auto",
//         overflowY: "hidden",

//         "& .MuiDataGrid-root": {
//           border: "none",
//           borderRadius: "1rem",
//           height: "100%",
//           minWidth: {
//             xs: "900px",
//             md: "100%",
//           },
//         },
//         "& .MuiDataGrid-cell": {
//           borderBottom: "none",
//         },
//         "& .MuiDataGrid-columnHeaders": {
//           backgroundColor: theme.palette.background.alt,
//           color: theme.palette.secondary[100],
//         },
//         "& .MuiDataGrid-virtualScroller": {
//           backgroundColor: theme.palette.background.alt,
//         },
//         "& .MuiDataGrid-footerContainer": {
//           backgroundColor: theme.palette.background.alt,
//           color: theme.palette.secondary[100],
//           borderTop: "none",
//           paddingTop: 0,
//           paddingBottom: 0,
//         },
//         "& .MuiTablePagination-root": {
//           backgroundColor: theme.palette.background.alt,
//         },
//       }}
//     >
//       <DataGrid
//         loading={isLoading}
//         getRowId={(row) => row.id}
//         rows={consommations}
//         columns={columns}
//         components={{
//           NoRowsOverlay: () => (
//             <Box
//               sx={{
//                 width: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 height: "100%",
//                 color: theme.palette.secondary[200],
//               }}
//             >
//               <Typography variant="h6">
//                 {noResultsMessage || "Aucune donnée disponible"}
//               </Typography>
//             </Box>
//           ),
//         }}
//       />
//     </Box>
//   );
// };

// export default DataGridComponent;



// import { Box, Typography, useTheme } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";

// const DataGridComponent = ({
//     isLoading,
//     consommations,
//     columns,
//     noResultsMessage
// }) => {
//     const theme = useTheme();

//     return (
//         <Box
//             gridColumn="span 8"
//             gridRow="span 3"
//             sx={{
//                 "& .MuiDataGrid-root": {
//                     border: "none",
//                     borderRadius: "5rem",
//                 },
//                 "& .MuiDataGrid-cell": {
//                     borderBottom: "none",
//                 },
//                 "& .MuiDataGrid-columnHeaders": {
//                     backgroundColor: theme.palette.background.alt,
//                     color: theme.palette.secondary[100],
//                 },
//                 "& .MuiDataGrid-virtualScroller": {
//                     backgroundColor: theme.palette.background.alt,
//                 },
//                 "& .MuiDataGrid-footerContainer": {
//                     backgroundColor: theme.palette.background.alt,
//                     color: theme.palette.secondary[100],
//                     borderTop: "none",
//                     paddingTop: 0,
//                     paddingBottom: 0,
//                 },
//                 "& .MuiTablePagination-root": {
//                     backgroundColor: theme.palette.background.alt,
//                 },
//             }}
//         >
//             <DataGrid
//                 loading={isLoading}
//                 getRowId={(row) => row.id}
//                 rows={consommations}
//                 columns={columns}
//                 components={{
//                     NoRowsOverlay: () => (
//                         <Box
//                             sx={{
//                                 width: "100%", // Make sure the overlay occupies full width
//                                 display: "flex",
//                                 justifyContent: "center",
//                                 alignItems: "center",
//                                 height: "100%", // Full height of the container
//                                 color: theme.palette.secondary[200],
//                             }}
//                         >
//                             <Typography variant="h6">
//                                 {noResultsMessage || "Aucune donnée disponible"}
//                             </Typography>
//                         </Box>
//                     ),
//                 }}
//             />
//         </Box>
//     );
// };

// export default DataGridComponent;